import type { Metadata, Viewport } from "next";
import { CheckinQueryProvider } from "./providers";

export const metadata: Metadata = {
  title: "Check in — Alqove",
  description: "Start your in-store buy from your phone.",
  // Public, transactional surface — keep it out of search indexes.
  robots: { index: false, follow: false },
};

export const viewport: Viewport = {
  width: "device-width",
  initialScale: 1,
  // Allow zoom for accessibility (WCAG-AA); don't lock scaling.
  maximumScale: 5,
  themeColor: "#0f172a",
};

/**
 * Minimal public layout for the check-in lane. No buyer/seller nav, no auth
 * gating — this group is served on `checkin.alqove.com` (Task 6) and stays
 * isolated from the main app's storage/cookies. The branding shell itself is
 * anonymous; only client components inside read the optional session token.
 */
export default function CheckinLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <CheckinQueryProvider>
      <div className="min-h-screen bg-slate-50 text-slate-900 flex flex-col">
        {children}
      </div>
    </CheckinQueryProvider>
  );
}
